import Swiper, {Navigation, Autoplay, EffectFade} from 'swiper'
Swiper.use([Navigation, Autoplay, EffectFade]);
import gsap from "gsap";
import { SplitText } from "../../plugins/gsap/SplitText";

gsap.registerPlugin(SplitText);

class VerticalTxo {
    constructor() {
        this.init();
    }

    init() {
        this.initHeroAnimationX();
        this.initSliders();
    }

    initHeroAnimationX() {
        const heroEl = document.querySelector('.hero-txo-microsite-x');
        if(!heroEl) {
            return;
        }

        const title = heroEl.querySelector('.title');
        this.splitTextChar = new SplitText(title, {type: "words,chars", wordsClass: "hero-word", charsClass: "hero-char"});
        this.chars = this.splitTextChar.chars;
        const header = heroEl.querySelector('.hero-img-x');
        gsap.set('.hero-content', {opacity: 1});

        gsap.from(this.chars, {
            autoAlpha: 0,
            duration: 1,
            stagger: 0.12,
            ease: "expo.out",
            onComplete: () => {
                gsap.to(header, {opacity: 1, duration: 1, ease: "power2.out"});
            }
        })

        this.neonLampAnimation(heroEl);
    }

    neonLampAnimation = (heroEl) => {
        const header2 = heroEl.querySelector('.header-x-2');

        function getRandom(min, max) {
            return Math.random() * (max - min) + min;
        }

        const onDelayRange = {min: 0.5, max: 1};
        const offDelayRange = {min: 1, max: 3};
        const flickerDuration = 0.8;
        const flickerOpacity = 0.2;
        const lightDuration = 0.05;
        const flickerStartAttemptsRange = {min: 1, max: 3};


        const flicker = gsap.fromTo(header2, {
            opacity: 1,
        }, {
            opacity: flickerOpacity,
            duration: flickerDuration,
            repeat: -1,
            yoyo: true,
            ease: "none"
        });
    }

    neonLampAnimation2 = (heroEl) => {
        const header2 = heroEl.querySelector('.header-x-2');

        function getRandom(min, max) {
            return Math.random() * (max - min) + min;
        }

        const onDelayRange = {min: 0.5, max: 1};
        const offDelayRange = {min: 1, max: 3};
        const flickerDuration = 0.05;
        const flickerOpacity = 0.9;
        const lightDuration = 0.05;
        const flickerStartAttemptsRange = {min: 1, max: 3};


        const flicker = gsap.fromTo(header2, {
            opacity: 1,
        }, {
            opacity: flickerOpacity,
            duration: flickerDuration,
            repeat: -1,
            yoyo: true,
            ease: "none"
        });

        const lightSwitch = gsap.timeline({
            repeat: 0,
        });

        const attempts = Math.round(getRandom(flickerStartAttemptsRange.min, flickerStartAttemptsRange.max));

        for(let i = 0; i < attempts; i++) {
            lightSwitch.to(header2, {
                opacity: 1,
                duration: lightDuration,
                delay: i === 0 ? 0 : getRandom(onDelayRange.min, onDelayRange.max),
                ease: "power1.inOut",
                onComplete: () => { flicker.restart(); }
            });

            lightSwitch.to(header2, {
                opacity: 0,
                duration: lightDuration,
                ease: "power1.inOut",
                onStart: () => { flicker.pause(); }
            });
        }

        lightSwitch.to(header2, {
            opacity: 1,
            duration: lightDuration,
            ease: "power1.inOut",
            onComplete: () => { flicker.restart(); }
        });

        lightSwitch.to(header2, {
            opacity: 0,
            duration: lightDuration,
            delay: getRandom(offDelayRange.min, offDelayRange.max),
            ease: "power1.inOut",
            onStart: () => { flicker.pause(); },
            onComplete: () => {
                flicker.kill();
                lightSwitch.kill();
                this.neonLampAnimation(heroEl);
            }
        });
    }

    initSliders() {

        this.swiperPortflio = new Swiper('.portfolio-slider', {
            slidesPerView: 1,
            loop: true,
            allowTouchMove: false,
            watchSlidesProgress: true,
            autoplay: {
                delay: 2500,
            },
            speed: 1200,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
            on: {
                slideChange(swiper) {
                    const previousSlide = swiper.slides[swiper.previousIndex];
                    const nextSlide = swiper.slides[swiper.activeIndex];

                    if (previousSlide) {
                        gsap.fromTo(previousSlide.querySelector('.avatar-col'), {x: 0}, {
                            duration: 2.4,
                            x: -50,
                            ease: "power2.out",
                        });
                    }

                    gsap.fromTo(nextSlide.querySelector('.avatar-col'), {
                        x: 50,
                    }, {
                        duration: 2.4,
                        x: 0,
                        ease: "power2.out"
                    });
                }
            }
        });


        const swiperAlumni = new Swiper('.alumni-slider', {
            slidesPerView: '1',
            autoHeight: false,
            watchSlidesProgress: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            speed: 600,
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            on: {
                slideChange(swiper) {
                    const previousSlide = swiper.slides[swiper.previousIndex];
                    const nextSlide = swiper.slides[swiper.activeIndex];

                    if (previousSlide) {
                        // gsap.fromTo(previousSlide.querySelectorAll('.alumni-slider-item'), {x: 0}, {
                        //     duration: 1.2,
                        //     x: -50,
                        //     stagger: 0.1,
                        //     ease: "power2.out",
                        // });

                        const previousSlideIndex = previousSlide.dataset.alumniBg;
                        if(previousSlideIndex != null) {
                            gsap.fromTo(`.alumni-bg-img-${previousSlideIndex}`, {opacity: 1}, {
                                duration: 1.2,
                                opacity: 0,
                            });
                        }
                    }

                    // gsap.fromTo(nextSlide.querySelectorAll('.alumni-slider-item'), {
                    //     x: 50,
                    // }, {
                    //     duration: 1.2,
                    //     x: 0,
                    //     stagger: 0.1,
                    //     ease: "power2.out"
                    // });

                    const nextSlideIndex = nextSlide.dataset.alumniBg;
                    if(nextSlideIndex != null) {
                        gsap.fromTo(`.alumni-bg-img-${nextSlideIndex}`, {opacity: 0}, {
                            duration: 1.2,
                            opacity: 1,
                        });
                    }
                }
            }
        });
    }
}

export default VerticalTxo
